import { render, staticRenderFns } from "./form-wizard-vehicle.vue?vue&type=template&id=f27a48f8"
import script from "./form-wizard-vehicle.vue?vue&type=script&lang=js"
export * from "./form-wizard-vehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports